import React, { useEffect } from 'react';
import { Close } from '../components/Icons';

export default function Modal({ title, children, onClose, footer, wide = false }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="cms-modal-overlay" onMouseDown={onClose}>
      <div className={`cms-modal${wide ? ' is-wide' : ''}`} role="dialog" aria-modal="true" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <div className="cms-modal-head">
          <h2>{title}</h2>
          <button type="button" className="docs-icon-btn" onClick={onClose} aria-label="Close"><Close size={18} /></button>
        </div>
        <div className="cms-modal-body">{children}</div>
        {footer && <div className="cms-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}

export function Field({ label, hint, children }) {
  return (
    <label className="cms-field">
      <span className="vt-eyebrow">{label}</span>
      {children}
      {hint && <span className="cms-hint">{hint}</span>}
    </label>
  );
}
